export default __webpack_public_path__ + "static/media/ic-ops.e5c145ba.svg";